import { useMemo } from "react";

export const useRouterDetectNavigation = (activitiesInformation) => {
	const navigateRoute = useMemo(() => {
		let route = "/home1/introduction";
		let isUndefined = false;
		for (const [, value] of Object.entries(activitiesInformation)) {
			const { task } = value;

			for (let index = 0; index < task.length; index++) {
				const element = task[index];
				if (element.isComplete === undefined) {
					route = element?.url ?? route;
					isUndefined = true;
					break;
				}
			}
			if (isUndefined) {
				break;
			}
		}
		// console.log(route);
		return route;
	}, [activitiesInformation]);
	return navigateRoute;
};
